export type LayUpStatus =
  | 'LayUpInProgress'
  | 'LayUpPaused'
  | 'CheckPending'
  | 'Checking'
  | 'Checked';

export type DerivedLayUpStatus = 'Missing' | 'CheckedMissing';

export type LayUpStatuses = LayUpStatus | DerivedLayUpStatus;

export type LayUpStatusFilter = LayUpStatuses | 'All';

export const LAYUP_STATUS_OPTION: Record<LayUpStatuses, string> = {
  LayUpInProgress: 'In progress',
  LayUpPaused: 'Paused',
  CheckPending: 'Requires check',
  Checking: 'Checking',
  Checked: 'Checked',
  Missing: 'Missing',
  CheckedMissing: 'Checked missing',
};
